var _rect, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 232,
    viewBox: "0 0 58.737 61.383",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65929,
    y: 0.65929,
    width: 57.419,
    height: 60.065,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#aa9de2",
    strokeMiterlimit: 10,
    strokeWidth: 0.26025
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.081,
    y: 13.494,
    width: 18.521,
    height: 2.6458,
    rx: 1.3229,
    ry: 1.3229,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4396,
    y: 13.494,
    width: 9.525,
    height: 2.6458,
    rx: 1.3229,
    ry: 1.3229,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4396,
    y: 8.7313,
    width: 25.135,
    height: 2.9104,
    rx: 1.4552,
    ry: 1.4552,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4396,
    y: 2.9104,
    width: 37.042,
    height: 3.9687,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#0100ff"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 3.5909,
    y: 18.937,
    width: 52.085,
    height: 32.506,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#aa9de2",
    strokeMiterlimit: 10,
    strokeWidth: 0.3026,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "submit",
    transform: "translate(-.2935 -1.1837)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.817,
    y: 54.894,
    width: 19.012,
    height: 5.5571,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#679b34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.77 58.117 2.0374-2.0884c0.0935-0.0958 0.24777-0.0978 0.34366-4e-3l0.34844 0.34004c0.0958 0.0934 0.0978 0.24776 4e-3 0.34365l-2.5452 2.6088c-0.0931 0.09561-0.24704 0.09777-0.34293 0.0049l-1.4672-1.4203c-0.0962-0.09314-0.0986-0.24748-5e-3 -0.34351l0.33859-0.34988c0.0932-0.0962 0.24749-0.0986 0.34352-6e-3l0.94491 0.9147z",
    fill: "#fafaff",
    fillRule: "evenodd",
    strokeWidth: 0.0040177
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "submit",
    transform: "translate(-23.086 -1.1837)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.817,
    y: 54.894,
    width: 19.012,
    height: 5.5571,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ff8033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.147 55.955c-0.06185 0-0.12372 0.02368-0.1711 0.07102l-0.29934 0.29934c-0.09476 0.09475-0.09476 0.24738 0 0.34212l1.0049 1.0049-1.0049 1.0049c-0.09476 0.09475-0.09476 0.24738 0 0.34212l0.29934 0.29934c0.09476 0.09475 0.24738 0.09475 0.34212 0l1.0049-1.0049 1.0049 1.0049c0.09475 0.09475 0.24738 0.09475 0.34212 0l0.29934-0.29934c0.09475-0.09476 0.09475-0.24738 0-0.34212l-1.0049-1.0049 1.0049-1.0049c0.09475-0.09475 0.09475-0.24738 0-0.34212l-0.29934-0.29934c-0.09476-0.09476-0.24738-0.09476-0.34212 0l-1.0049 1.0049-1.0049-1.0049c-0.04734-0.04734-0.1092-0.07102-0.17104-0.07102z",
    fill: "#fff",
    strokeWidth: 0.003013
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewForm);
export default __webpack_public_path__ + "static/media/review-form.e76fd2f6d382430bb1422f2926b63a39.svg";
export { ForwardRef as ReactComponent };